<template>
  <div class="main-container">
    <!-- 查询栏 -->
    <div class="query-nav">
      <el-form ref="queryFormRef" :model="queryForm" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item prop="orgName" label="机构名称">
              <el-input v-model.trim="queryForm.orgName" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-button type="primary" style="margin-right: 6px" @click="handleSearch"
              >搜索</el-button
            >
            <el-button @click="handleReset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 表格区域 -->
    <div class="table">
      <el-table :data="orgList" v-loading="tableLoading" stripe border>
        <el-table-column
          type="index"
          label="序号"
          width="60"
          align="center"
          :resizable="false"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="orgName"
          label="机构名称"
          align="center"
          :resizable="false"
        ></el-table-column>
        <el-table-column
          width="200px"
          prop="deviceSize"
          label="设备数量"
          align="center"
          :resizable="false"
        ></el-table-column>
        <el-table-column width="200px" label="操作" align="center" :resizable="false">
          <template slot-scope="{ row }">
            <el-tooltip class="item" effect="dark" content="查看详情" placement="top">
              <i
                class="iconfont iconcaozuo-8chakanxiangqing_1"
                style="margin-right: 16px"
                @click="handleViewDetail(row)"
              ></i>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="授权" placement="top">
              <i class="iconfont iconcaidan1-3rizhiguanli_1" @click="handleGrant(row)"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页区域 -->
    <div class="page">
      <el-pagination
        :total="total"
        :current-page="queryForm.pageNo"
        :page-size="queryForm.pageSize"
        :page-sizes="[10, 20, 30, 50]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>

    <!-- 查看详情 -->
    <el-dialog
      title="查看详情"
      :visible.sync="detailDialogVisible"
      width="800px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @closed="closeDetailDialog"
    >
      <el-form label-width="80px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="机构名称">{{ grantedOrgDetail.orgName }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设备数量">{{ grantedOrgDetail.deviceSize }}</el-form-item>
          </el-col>
        </el-row>
        <div class="divide-bar">授权明细</div>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="授权机构">
              <el-select
                style="width: 100%"
                v-model="grantedOrgId"
                placeholder="请选择"
                @change="getDeviceDetail"
              >
                <el-option
                  v-for="item in grantedOrgList"
                  :key="item.orgId"
                  :label="item.orgName"
                  :value="item.orgId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="tip" v-if="grantedDeviceDetailList.length === 0">暂无明细，请先选择授权机构~</div>
      <div v-else>
        <el-table :data="grantedDeviceDetailList" stripe border>
          <el-table-column
            type="index"
            label="序号"
            width="60"
            align="center"
            :resizable="false"
          ></el-table-column>
          <el-table-column
            prop="deviceName"
            label="设备名称"
            align="center"
            :resizable="false"
          ></el-table-column>
          <el-table-column
            prop="deviceNo"
            label="设备编号"
            align="center"
            :resizable="false"
          ></el-table-column>
          <el-table-column
            prop="deviceCategoryName"
            label="设备大类"
            align="center"
            :resizable="false"
          ></el-table-column>
          <el-table-column
            prop="deviceTypeName"
            label="设备小类"
            align="center"
            :resizable="false"
          ></el-table-column>
          <el-table-column label="操作" align="center" :resizable="false">
            <template slot-scope="{ row }">
              <span style="color: #f56c6c; cursor: pointer" @click="cancelGranted(row)"
                >取消授权</span
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <!-- 授权对话框 -->
    <el-dialog
      title="授权"
      :visible.sync="grantDialogVisible"
      width="450px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @closed="closeGrantDialog"
    >
      <el-form ref="paramsFormRef" :model="paramsForm" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item
              prop="grantedOrgId"
              label="授权机构"
              :rules="{ required: true, message: '请选择要授权给的机构', trigger: 'change' }"
            >
              <el-select
                filterable
                style="width: 100%"
                v-model="paramsForm.grantedOrgId"
                placeholder="请先输入/选择机构"
                @change="handleChangeOrg"
              >
                <el-option
                  style="max-width: 330px !important"
                  v-for="item in orgListAll"
                  :key="item.orgId"
                  :label="item.orgName"
                  :value="item.orgId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-tree
        ref="authDeviceTreeRef"
        v-loading="treeLoading"
        check-strictly
        default-expand-all
        :data="deviceTree"
        show-checkbox
        node-key="id"
        :props="treeProps"
        @check="getCheckedDeviceList"
      ></el-tree>
      <!-- :default-checked-keys="defaultCheckedList" -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeGrantDialog">取消</el-button>
        <el-button type="primary" :loading="btnLoading" @click="submitGrant">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import deviceApi from 'api/home/device.js';

export default {
  data() {
    return {
      total: 0,
      queryForm: {
        pageNo: 1,
        pageSize: 10,
        orgName: ''
      },
      tableLoading: true,
      orgList: [],
      grantedOrgDetail: {},
      grantedOrgList: [],
      detailDialogVisible: false,
      // 查看详情本身的机构 id
      orgId: '',
      // 查看详情下拉选择的机构 id
      grantedOrgId: '',
      grantedDeviceDetailList: [],
      grantDialogVisible: false,
      orgListAll: [],
      // 授权用参数
      paramsForm: {
        orgId: '',
        grantedOrgId: '',
        deviceIdList: []
      },
      treeLoading: false,
      deviceTree: [],
      treeProps: {
        children: 'children',
        label: 'name'
      },
      btnLoading: false
      // defaultCheckedList: []
    };
  },
  created() {
    this.getOrgListData();
  },
  methods: {
    // 获取授权机构列表
    getOrgListData() {
      this.tableLoading = true;
      deviceApi
        .getOrgListTable(this.queryForm)
        .then(res => {
          if (res.data.code === 200) {
            this.total = res.data.data.totalRows;
            this.orgList = res.data.data.rows;
          }
          this.tableLoading = false;
          // else {
          //   this.$message.error(res.data.message);
          //   this.tableLoading = false;
          // }
        })
        .catch(err => {
          this.tableLoading = false;
        });
    },
    // 分页
    handleSizeChange(val) {
      this.queryForm.pageNo = 1;
      this.queryForm.pageSize = val;
      this.getOrgListData();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNo = val;
      this.getOrgListData();
    },
    // 搜索
    handleSearch() {
      this.queryForm.pageNo = 1;
      this.getOrgListData();
    },
    // 重置
    handleReset() {
      this.$refs.queryFormRef.resetFields();
      this.queryForm.pageNo = 1;
      this.queryForm.pageSize = 10;
      this.getOrgListData();
    },
    // 获取授权的机构下拉列表
    getGrantedOrgListData(orgId) {
      deviceApi.getGrantedOrgList(orgId).then(res => {
        if (res.data.code === 200) {
          this.grantedOrgList = res.data.data;
        }
        // else {
        //   this.$message.error(res.data.message);
        // }
      });
    },
    // 查看详情
    handleViewDetail(row) {
      this.orgId = row.orgId;
      this.getGrantedOrgListData(row.orgId);
      this.grantedOrgDetail.orgName = row.orgName;
      this.grantedOrgDetail.deviceSize = row.deviceSize;
      this.detailDialogVisible = true;
    },
    // 查看详情选择授权给的机构后，获取设备详情
    getDeviceDetail() {
      const params = {};
      params.orgId = this.orgId;
      params.grantedOrgId = this.grantedOrgId;
      deviceApi.getGrantedDeviceDetail(params).then(res => {
        if (res.data.code === 200) {
          this.grantedDeviceDetailList = res.data.data;
        }
        // else {
        //   this.$message.error(res.data.message);
        // }
      });
    },
    // 关闭详情框
    closeDetailDialog() {
      this.grantedOrgId = '';
      this.grantedDeviceDetailList = [];
    },
    // 取消设备授权
    cancelGranted(row) {
      const params = {};
      params.orgId = this.grantedOrgId;
      params.id = row.id;
      this.$confirm('确定取消授权？', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deviceApi.postCancelGranted(params).then(res => {
          if (res.data.code === 200) {
            this.$message({
              message: '取消授权成功',
              type: 'success'
            });
            this.getDeviceDetail();
          }
          // else {
          //   this.$message.error(res.data.message);
          // }
        });
      });
    },
    // 查询所有机构
    getOrgListAll() {
      deviceApi.getOrgList().then(res => {
        if (res.data.code === 200) {
          // console.log(res);
          this.orgListAll = res.data.data;
          // 除掉自身的机构列表
          this.orgListAll.splice(
            this.orgListAll.findIndex(item => item.orgId === this.paramsForm.orgId),
            1
          );
        }
        // else {
        //   this.$message.error(res.data.message);
        // }
      });
    },
    // 点击授权
    handleGrant(row) {
      this.paramsForm.orgId = row.orgId;
      this.getOrgListAll();
      this.getDeviceListTree();
      this.grantDialogVisible = true;
    },
    // 查询原机构设备树
    getDeviceListTree() {
      this.treeLoading = true;
      deviceApi
        .getGrantTree(this.paramsForm.orgId)
        .then(res => {
          if (res.data.code) {
            // this.deviceTree = res.data.data;

            this.deviceTree = this.findDisabled(res.data.data, this.paramsForm.deviceIdList);
            // console.log(this.deviceTree);
          }
          // else {
          //   this.$message.error(res.data.message);
          // }
          this.treeLoading = false;
        })
        .catch(err => {
          this.treeLoading = false;
        });
    },
    findDisabled(tree, idList) {
      for (let i = 0; i < idList.length; i++) {
        const id = idList[i];

        tree.map(item => {
          if (item.id === id) {
            item.disabled = true;
          } else if (item.children && item.children.length !== 0) {
            this.findDisabled(item.children, [id]);
          }

          return item;
        });
      }

      return tree;
    },
    // 选择授权机构事件
    handleChangeOrg(value) {
      //  console.log(value);
      this.treeLoading = true;
      deviceApi
        .getGrantedDeviceDetail({
          orgId: this.paramsForm.orgId,
          grantedOrgId: value
        })
        .then(res => {
          if (res.data.code === 200) {
            this.paramsForm.deviceIdList = res.data.data.map(item => item.id);
            this.getDeviceListTree();
            this.$nextTick(() => {
              this.$refs.authDeviceTreeRef.setCheckedKeys(this.paramsForm.deviceIdList);
            });
          }
          // else {
          //   this.$message.error(res.data.message);
          // }
          this.treeLoading = false;
        })
        .catch(err => {
          this.treeLoading = false;
        });
    },

    // 获取所选设备id数组
    getCheckedDeviceList(data, list) {
      this.paramsForm.deviceIdList = list.checkedKeys;
    },
    // 取消按钮
    closeGrantDialog() {
      this.grantDialogVisible = false;
      this.$refs.paramsFormRef.resetFields();
      this.paramsForm.deviceIdList = [];
      this.orgListAll = [];
      this.deviceTree = [];
      this.defaultCheckedList = [];
      this.$refs.authDeviceTreeRef.setCheckedKeys([]);
    },
    // 确定授权
    submitGrant() {
      this.btnLoading = true;
      this.$refs.paramsFormRef.validate(valid => {
        if (!valid) {
          this.btnLoading = false;
          return;
        }
        if (this.paramsForm.deviceIdList.length === 0) {
          this.btnLoading = false;
          this.$message({
            message: '请选择要授权的设备',
            type: 'warning'
          });
          return;
        }
        deviceApi
          .postDeviceGranted(this.paramsForm)
          .then(res => {
            if (res.data.code === 200) {
              this.btnLoading = false;
              this.$message({
                message: '设备授权成功!',
                type: 'success'
              });
              this.closeGrantDialog();
            }
            // else {
            //   this.$message.error(res.data.message);
            // }
          })
          .catch(() => {
            this.btnLoading = false;
          });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.main-container {
  padding: 16px;

  .query-nav {
    height: 40px;
  }

  .page {
    margin: 16px 0;
    float: right;
  }
}

.divide-bar {
  height: 32px;
  background: #f3f6fe;
  font-size: 12px;
  color: #90939b;
  line-height: 32px;
  padding: 0 8px;
  margin-bottom: 16px;
}

.tip {
  height: 300px;
  line-height: 300px;
  text-align: center;
  font-size: 12px;
  color: #90939b;
}

.iconfont {
  font-size: 28px;
  color: #409dff;
  cursor: pointer;
}
</style>
